import { getLocale, useIntl, useSelector } from 'umi';
import { getMonetUnit } from '@/pages/dashboard/utils/moneyUnit';
import { columnWidth, upDownWidth } from '@/pages/dashboard/_config/constant';
import RainbowTableModal from '@/pages/dashboard/components/RainbowTableModal';

export default function useTableLoclesIntl() {
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const gameCode = useSelector((state: any) => {
    return state.dashboard?.currentGame?.game_code;
  });
  /**
   * separated分组标识
   */
  const GROUPS = {
    separated: formatMessage({ id: 'common_Separated' }),
  };

  /**
   * Accumulated筛选器默认值
   */
  const DEFAULT_VALUE = 'accumulated';
  /**
   * Accumulated选项组配置
   */
  const ACCUMULATED_OPTIONS = [{
    value: DEFAULT_VALUE,
    text: formatMessage({ id: 'common_Accumulated' }),
  }];

  /**
   * Separated选项组配置
   */
  const SEPARATED_OPTIONS = [
    {
      groupKey: 'separated',
      value: 'zone',
      text: formatMessage({ id: 'common_by_Zone' }),
    },
    {
      groupKey: 'separated',
      value: 'region',
      text: formatMessage({ id: 'common_by_Region' }),
    },
    {
      groupKey: 'separated',
      value: 'country',
      text: formatMessage({ id: 'common_by_Country' }),
    },
    {
      groupKey: 'separated',
      value: 'system',
      text: formatMessage({ id: 'common_by_System' }),
    },
    {
      groupKey: 'separated',
      value: 'channel',
      text: formatMessage({ id: 'common_by_Channel' }),
    },
  ];
  const GROUP_BY_TABLE = {
    zone: formatMessage({ id: 'common_Zone' }),
    region: formatMessage({ id: 'common_Region' }),
    country: formatMessage({ id: 'common_Country' }),
    channel: formatMessage({ id: 'common_Channel' }),
    system: formatMessage({ id: 'common_System' }),
    language: formatMessage({ id: 'common_Language' }),
  };


  const GROUP_BY_INDEX = {
    zone: 0,
    region: 1,
    country: 2,
    system: 3,
    channel: 4,
    language: 5
  };

  const GROUP_BY_KEY_TABLE = Object.keys(GROUP_BY_TABLE);

  /**
   *运算筛选器的key
   */
  const OPERATION_KEY_LIST = {
    Sum: 'sum',
    Average: 'avg',
    Max: 'max',
    Min: 'min',
  };

  /**
   * 运算筛选器key
   */
  const OPERATION_ROW = {
    [OPERATION_KEY_LIST.Sum]: formatMessage({ id: 'common_Sum' }),
    [OPERATION_KEY_LIST.Max]: formatMessage({ id: 'common_Max' }),
    [OPERATION_KEY_LIST.Min]: formatMessage({ id: 'common_Min' }),
    [OPERATION_KEY_LIST.Average]: formatMessage({ id: 'common_Average' }),
  };

  /**
   * 获取运算符的key 判断当前行是否是运算符
   */
  const OPERATION_GROUP = Object.keys(OPERATION_ROW);

  /**
   * 获取运算符的values
   */
  const OPERATION_KEY_GROUP = Object.values(OPERATION_KEY_LIST);

  /**
   * 宽表列名配置
   */




  // 日
  const COLUMN_CONFIG_DAY = {
    'total_users': {
      index: 0,
      width: columnWidth.ten,
      onlyValueWidth: locale === 'en-US' ? columnWidth.ten - upDownWidth : 152,
      name: formatMessage({ id: 'overview_TRU' }),
      rainbowKey: 'TNU',
      isUserType: true,
    },
    'new_users': {
      index: 1,
      width: columnWidth.eight,
      rainbowKey: 'New',
      onlyValueWidth: columnWidth.eight - upDownWidth,
      name: formatMessage({ id: 'overview_New' }),
      isUserType: true,
    },
    'active_users': {
      index: 2,
      width: columnWidth.eight,
      rainbowKey: 'DAU',
      onlyValueWidth: columnWidth.eight - upDownWidth,
      name: formatMessage({ id: 'overview_daily_DAU' }),
      isUserType: true,
    },
    'pay_amount': {
      index: 3,
      width: columnWidth.twelve,
      onlyValueWidth: columnWidth.twelve - upDownWidth,
      name: formatMessage({ id: 'overview_Revenue($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'Revenue($)',
    },
    'd2': {
      index: 7,
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D2' }),
      rainbowKey: 'D2',
      isPercent: true,
      decimals: 2,
    },
    'd3': {
      index: 8,
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D3' }),
      rainbowKey: 'D3',
      isPercent: true,
      decimals: 2,
    },
    'd4': {
      index: 19,
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D4' }),
      rainbowKey: 'D4',
      isPercent: true,
      decimals: 2,
    },
    'd5': {
      index: 20,
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D5' }),
      rainbowKey: 'D5',
      isPercent: true,
      decimals: 2,
    },
    'd6': {
      index: 21,
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D6' }),
      rainbowKey: 'D6',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'd7': {
      index: 9,
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D7' }),
      rainbowKey: 'D7',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'd14': {
      index: 21,
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D14' }),
      rainbowKey: 'D14',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'd21': {
      index: 21,
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D21' }),
      rainbowKey: 'D21',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'd28': {
      index: 21,
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D28' }),
      rainbowKey: 'D28',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'd30': {
      index: 9,
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D30' }),
      rainbowKey: 'D30',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'pcu': {
      index: 4,
      width: columnWidth.seven,
      onlyValueWidth: locale === 'en-US' ? columnWidth.seven - upDownWidth : 152,
      name: formatMessage({ id: 'overview_PCU' }),
      rainbowKey: 'PCU',
      isUserType: true,
      dodDecimals: 1,
    },
    'acu': {
      index: 5,
      width: columnWidth.seven,
      onlyValueWidth: locale === 'en-US' ? columnWidth.seven - upDownWidth : 152,
      name: formatMessage({ id: 'overview_ACU' }),
      rainbowKey: 'ACU',
      isUserType: true,
      dodDecimals: 1,
    },
    'aot': {
      index: 6,
      width: columnWidth.eight,
      onlyValueWidth: locale === 'en-US' ? 204 : columnWidth.twelve,
      name: formatMessage({ id: 'overview_AOT(min)' }),
      rainbowKey: 'Avg.Playtime(min)',
      dodDecimals: 1,
    },
    'paid_users': {
      index: 10,
      width: columnWidth.six,
      onlyValueWidth: locale === 'en-US' ? 104 : 120,
      name: formatMessage({ id: 'overview_Payer' }),
      rainbowKey: 'Payer',
      isUserType: true,
      dodDecimals: 1,
    },
    'payer_rate': {
      index: 11,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 116 : 136,
      name: formatMessage({ id: 'overview_Payer%' }),
      rainbowKey: 'Payer%',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'arpu': {
      index: 12,
      width: locale === 'en-US' ? columnWidth.five : 176,
      onlyValueWidth: locale === 'en-US' ? 146 : 176,
      name: formatMessage({ id: 'overview_ARPU($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'ARPU($)',
      dodDecimals: 1,
    },
    'arppu': {
      index: 13,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 146 : 176,
      name: formatMessage({ id: 'overview_ARPPU($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'ARPPU($)',
      dodDecimals: 1,
    },
    'new_paid_users': {
      index: 14,
      width: locale === 'en-US' ? columnWidth.eight : columnWidth.seven,
      onlyValueWidth: locale === 'en-US' ? 184 : 156,
      name: formatMessage({ id: 'overview_New_Payer' }),
      rainbowKey: 'First-time Payer',
      isUserType: true,
      dodDecimals: 1,
    },
    'new_pay_amount': {
      index: 16,
      width: locale === 'en-US' ? 260 : columnWidth.fifteen,
      onlyValueWidth: locale === 'en-US' ? 260 : 205,
      name: formatMessage({ id: 'overview_Revenue(new_payer)' }),
      rainbowKey: 'Revenue(first-time payer)',
      dodDecimals: 1,
    },
    'new_arppu': {
      index: 17,
      width: locale === 'en-US' ? columnWidth.eighteen : columnWidth.thirteen, // 需要取列长
      onlyValueWidth: locale === 'en-US' ? columnWidth.eighteen : columnWidth.thirteen,
      name: formatMessage({ id: 'overview_New_Users_ARPPU($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'First-time Payer ARPPU($)',
      dodDecimals: 1,
    },
    'alc': {
      index: 18,
      width: locale === 'en-US' ? 200 : 180,
      onlyValueWidth: locale === 'en-US' ? 200 : 180,
      name: formatMessage({ id: 'overview_Avg.Login_Count' }),
      rainbowKey: 'Sessions per user',
      dodDecimals: 1,
    },
    'retention_users': {
      index: 23,
      width: locale === 'en-US' ? 230 : columnWidth.ten,
      onlyValueWidth: locale === 'en-US' ? 226 : 211,
      name: formatMessage({ id: 'overview_daily_DAU_Retention_Users' }),
      rainbowKey: 'DAU Retention Users',
      isUserType: true,
      dodDecimals: 1,
    },
    'churn_users': {
      index: 24,
      width: columnWidth.nine,
      onlyValueWidth: locale === 'en-US' ? 154 : columnWidth.nine - upDownWidth,
      name: formatMessage({ id: 'overview_daily_Churn_Users' }),
      rainbowKey: 'Churn Users',
      isUserType: true,
      dodDecimals: 1,
    },
    'churn_rate': {
      index: 25,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 120 : 104,
      name: formatMessage({ id: 'overview_Churn%' }),
      rainbowKey: 'Churn%',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'return_users': {
      index: 26,
      width: locale === 'en-US' ? columnWidth.ten : columnWidth.nine,
      onlyValueWidth: locale === 'en-US' ? 200 : columnWidth.nine - upDownWidth,
      name: formatMessage({ id: 'overview_daily_DAU_Return_Users' }),
      rainbowKey: 'DAU Return Users',
      isUserType: true,
      dodDecimals: 1,
    },
    'weighted_d2': {
      index: 27,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 162 : 120,
      name: formatMessage({ id: 'overview_daily_Weighted_D2' }),
      rainbowKey: 'Weighted D2',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_d3': {
      index: 28,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 160 : 118,
      name: formatMessage({ id: 'overview_daily_Weighted_D3' }),
      rainbowKey: 'Weighted D3',
      isPercent: true,
      decimals: 2,

      dodDecimals: 1,
    },
    'weighted_d7': {
      index: 29,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 162 : 118,
      name: formatMessage({ id: 'overview_daily_Weighted_D7' }),
      rainbowKey: 'Weighted D7',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_d14': {
      index: 30,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 172 : 122,
      name: formatMessage({ id: 'overview_daily_Weighted_D14' }),
      rainbowKey: 'Weighted D14',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_d21': {
      index: 30,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 172 : 122,
      name: formatMessage({ id: 'overview_daily_Weighted_D21' }),
      rainbowKey: 'Weighted D21',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_d28': {
      index: 30,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 172 : 122,
      name: formatMessage({ id: 'overview_daily_Weighted_D28' }),
      rainbowKey: 'Weighted D28',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_d30': {
      index: 30,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 172 : 122,
      name: formatMessage({ id: 'overview_daily_Weighted_D30' }),
      rainbowKey: 'Weighted D30',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'first_login_ratio': {
      index: 31,
      width: locale === 'en-US' ? 200 : columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 200 : columnWidth.five,
      name: formatMessage({ id: 'overview_daily_1st_Order_Login%' }),
      rainbowKey: '1st Order Login%',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'second_login_ratio': {
      index: 32,
      width: locale === 'en-US' ? 200 : columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 200 : columnWidth.five,
      name: formatMessage({ id: 'overview_daily_2nd_Order_Login%' }),
      rainbowKey: '2nd Order Login%',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
  };

  // 周
  const COLUMN_CONFIG_WEEK = {
    'total_users': {
      index: 0,
      width: columnWidth.ten,
      onlyValueWidth: locale === 'en-US' ? columnWidth.ten - upDownWidth : 152,
      name: formatMessage({ id: 'overview_TRU' }),
      rainbowKey: 'TNU',
      isUserType: true,
      dodDecimals: 1,
    },
    'new_users': {
      index: 1,
      width: columnWidth.nine,
      onlyValueWidth: columnWidth.nine - upDownWidth,
      name: formatMessage({ id: 'overview_New' }),
      rainbowKey: 'New',
      isUserType: true,
      dodDecimals: 1,
    },
    'avg_new_users': {
      index: 2,
      width: locale === 'en-US' ? columnWidth.seven : columnWidth.seven + 15,
      onlyValueWidth: locale === 'en-US' ? 176 : 200,
      name: formatMessage({ id: 'overview_weekly_Avg.Daily_New' }),
      rainbowKey: 'Avg.Daily New',
      isUserType: true,
      dodDecimals: 1,
    },
    'active_users': {
      index: 3,
      width: columnWidth.nine,
      onlyValueWidth: columnWidth.nine - upDownWidth,
      name: formatMessage({ id: 'overview_weekly_WAU' }),
      rainbowKey: 'WAU',
      isUserType: true,
      dodDecimals: 1,
    },
    'avg_active_users': {
      index: 4,
      width: columnWidth.eight,
      onlyValueWidth: locale === 'en-US' ? 180 : 158,
      name: formatMessage({ id: 'overview_weekly_Week_Avg.DAU' }),
      rainbowKey: 'Week Avg.DAU',
      isUserType: true,
      dodDecimals: 1,
    },
    'pay_amount': {
      index: 5,
      width: columnWidth.fifteen,
      onlyValueWidth: columnWidth.fifteen - upDownWidth,
      name: formatMessage({ id: 'overview_Revenue($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'Revenue($)',
      dodDecimals: 1,
    },
    'avg_pay_amount': {
      index: 6,
      width: locale === 'en-US' ? 252 : columnWidth.thirteen,
      onlyValueWidth: locale === 'en-US' ? 242 : 200,
      name: formatMessage({ id: 'overview_weekly_Week_Avg.Revenue($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'Week Avg.Revenue($)',
      dodDecimals: 1,
    },
    'pcu': {
      index: 7,
      width: columnWidth.seven,
      onlyValueWidth: locale === 'en-US' ? columnWidth.seven - upDownWidth : 156,
      name: formatMessage({ id: 'overview_PCU' }),
      rainbowKey: 'PCU',
      isUserType: true,
      dodDecimals: 1,
    },
    'acu': {
      index: 8,
      width: columnWidth.seven,
      onlyValueWidth: locale === 'en-US' ? columnWidth.seven - upDownWidth : 156,
      name: formatMessage({ id: 'overview_ACU' }),
      rainbowKey: 'ACU',
      isUserType: true,
      dodDecimals: 1,
    },
    'aot': {
      index: 9,
      width: columnWidth.eight,
      onlyValueWidth: locale === 'en-US' ? 204 : columnWidth.twelve,
      name: formatMessage({ id: 'overview_AOT(min)' }),
      rainbowKey: 'Avg.Playtime(min)',
      dodDecimals: 1,
    },
    'saot': {
      index: 29,
      width: columnWidth.eight,
      onlyValueWidth: locale === 'en-US' ? 264 : columnWidth.twelve,
      name: formatMessage({ id: 'overview_Avg_Daily_Playtime(min)' }),
      rainbowKey: 'Avg.Daily Playtime(min)',
      dodDecimals: 1,
    },
    'w2': {
      index: 10,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? columnWidth.five - upDownWidth : 120,
      name: formatMessage({ id: 'overview_weekly_W2' }),
      rainbowKey: 'W2',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'w3': {
      index: 11,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? columnWidth.five - upDownWidth : 114,
      name: formatMessage({ id: 'overview_weekly_W3' }),
      rainbowKey: 'W3',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'w4': {
      index: 12,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? columnWidth.five - upDownWidth : 114,
      name: formatMessage({ id: 'overview_weekly_W4' }),
      rainbowKey: 'W4',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'paid_users': {
      index: 13,
      width: columnWidth.seven,
      onlyValueWidth: locale === 'en-US' ? columnWidth.seven - upDownWidth : 120,
      name: formatMessage({ id: 'overview_Payer' }),
      rainbowKey: 'Payer',
      isUserType: true,
      dodDecimals: 1,
    },
    'payer_rate': {
      index: 14,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 118 : 136,
      name: formatMessage({ id: 'overview_Payer%' }),
      rainbowKey: 'Payer%',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'arpu': {
      index: 15,
      width: 171,
      onlyValueWidth: locale === 'en-US' ? 146 : 176,
      name: formatMessage({ id: 'overview_ARPU($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'ARPU($)',
      dodDecimals: 1,
    },
    'arppu': {
      index: 16,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 146 : 176,
      name: formatMessage({ id: 'overview_ARPPU($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'ARPPU($)',
      dodDecimals: 1,
    },
    'new_paid_users': {
      index: 17,
      width: columnWidth.eight,
      onlyValueWidth: locale === 'en-US' ? 184 : 152,
      name: formatMessage({ id: 'overview_New_Payer' }),
      rainbowKey: 'First-time Payer',
      isUserType: true,
      dodDecimals: 1,
    },
    'new_pay_amount': {
      index: 19,
      width: locale === 'en-US' ? 260 : columnWidth.fifteen,
      onlyValueWidth: locale === 'en-US' ? 260 : 205,
      name: formatMessage({ id: 'overview_Revenue(new_payer)' }),
      rainbowKey: 'Revenue(first-time payer)',
      dodDecimals: 1,
    },
    'new_arppu': {
      index: 20,
      width: locale === 'en-US' ? columnWidth.eighteen : columnWidth.thirteen, // 需要取列长
      onlyValueWidth: locale === 'en-US' ? columnWidth.eighteen : columnWidth.thirteen,
      name: formatMessage({ id: 'overview_New_Users_ARPPU($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'First-time Payer ARPPU($)',
      dodDecimals: 1,
    },
    'alc': {
      index: 21,
      width: locale === 'en-US' ? 200 : 180,
      onlyValueWidth: locale === 'en-US' ? 190 : 180,
      name: formatMessage({ id: 'overview_Avg.Login_Count' }),
      rainbowKey: 'Sessions per user',
      dodDecimals: 1,
    },
    'retention_users': {
      index: 22,
      width: locale === 'en-US' ? 230 : 214,
      onlyValueWidth: locale === 'en-US' ? 230 : 214,
      name: formatMessage({ id: 'overview_weekly_WAU_Retention_Users' }),
      rainbowKey: 'WAU Retention Users',
      isUserType: true,
      dodDecimals: 1,
    },
    'churn_users': {
      index: 23,
      width: columnWidth.ten,
      onlyValueWidth: locale === 'en-US' ? 154 : columnWidth.ten - upDownWidth,
      name: formatMessage({ id: 'overview_weekly_Churn_Users' }),
      rainbowKey: 'Churn Users',
      isUserType: true,
      dodDecimals: 1,
    },
    'churn_rate': {
      index: 24,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 120 : 104,
      name: formatMessage({ id: 'overview_Churn%' }),
      rainbowKey: 'Churn%',
      isPercent: true,
      decimals: 2,
      desc: 'Churn Users / Active Users Last Week',
      dodDecimals: 1,
    },
    'return_users': {
      index: 25,
      width: columnWidth.ten,
      onlyValueWidth: locale === 'en-US' ? 204 : columnWidth.ten - upDownWidth,
      name: formatMessage({ id: 'overview_weekly_WAU_Return_Users' }),
      rainbowKey: 'WAU Return Users',
      isUserType: true,
      dodDecimals: 1,
    },
    'weighted_w2': {
      index: 26,
      width: locale === 'en-US' ? columnWidth.six : columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 166 : 152,
      name: formatMessage({ id: 'overview_weekly_Weighted_W2' }),
      rainbowKey: 'Weighted W2',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_w3': {
      index: 27,
      width: locale === 'en-US' ? columnWidth.six : columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 166 : 146,
      name: formatMessage({ id: 'overview_weekly_Weighted_W3' }),
      rainbowKey: 'Weighted W3',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_w4': {
      index: 28,
      width: locale === 'en-US' ? columnWidth.six : columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 166 : 146,
      name: formatMessage({ id: 'overview_weekly_Weighted_W4' }),
      rainbowKey: 'Weighted W4',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
  };


  // 月
  const COLUMN_CONFIG_MONTH = {
    'total_users': {
      index: 0,
      width: columnWidth.ten,
      onlyValueWidth: locale === 'en-US' ? columnWidth.ten - upDownWidth : 152,
      name: formatMessage({ id: 'overview_TRU' }),
      rainbowKey: 'TNU',
      isUserType: true,
      dodDecimals: 1,
    },
    'new_users': {
      index: 1,
      width: columnWidth.nine,
      onlyValueWidth: columnWidth.nine - upDownWidth,
      name: formatMessage({ id: 'overview_New' }),
      rainbowKey: 'New',
      isUserType: true,
      dodDecimals: 1,
    },
    'avg_new_users': {
      index: 2,
      width: locale === 'en-US' ? columnWidth.seven : columnWidth.seven + 24,
      onlyValueWidth: locale === 'en-US' ? 180 : 200,
      name: formatMessage({ id: 'overview_monthly_Avg.Daily_New' }),
      rainbowKey: 'Avg.Daily New',
      isUserType: true,
      dodDecimals: 1,
    },
    'active_users': {
      index: 3,
      width: columnWidth.nine,
      onlyValueWidth: columnWidth.nine - upDownWidth,
      name: formatMessage({ id: 'overview_monthly_MAU' }),
      rainbowKey: 'MAU',
      isUserType: true,
      dodDecimals: 1,
    },
    'avg_active_users': {
      index: 4,
      width: columnWidth.nine,
      onlyValueWidth: locale === 'en-US' ? 200 : 154,
      name: formatMessage({ id: 'overview_monthly_Month_Avg.DAU' }),
      rainbowKey: 'Month Avg.DAU',
      isUserType: true,
      dodDecimals: 1,
    },
    'pay_amount': {
      index: 5,
      width: columnWidth.fifteen,
      onlyValueWidth: columnWidth.fifteen - upDownWidth,
      name: formatMessage({ id: 'overview_Revenue($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'Revenue($)',
      dodDecimals: 1,
    },
    'avg_pay_amount': {
      index: 6,
      width: locale === 'en-US' ? 250 : columnWidth.twelve, // 10位
      onlyValueWidth: locale === 'en-US' ? 250 : 192,
      name: formatMessage({ id: 'overview_monthly_Month_Avg.Revenue($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'Month Avg.Revenue($)',
      dodDecimals: 1,
    },
    'pcu': {
      index: 7,
      width: columnWidth.seven,
      onlyValueWidth: locale === 'en-US' ? columnWidth.seven - upDownWidth : 156,
      name: formatMessage({ id: 'overview_PCU' }),
      rainbowKey: 'PCU',
      isUserType: true,
      dodDecimals: 1,
    },
    'acu': {
      index: 8,
      width: columnWidth.seven,
      onlyValueWidth: locale === 'en-US' ? columnWidth.seven - upDownWidth : 156,
      name: formatMessage({ id: 'overview_ACU' }),
      rainbowKey: 'ACU',
      isUserType: true,
      dodDecimals: 1,
    },
    'aot': {
      index: 9,
      width: columnWidth.eight,
      onlyValueWidth: locale === 'en-US' ? 204 : columnWidth.twelve,
      name: formatMessage({ id: 'overview_AOT(min)' }),
      rainbowKey: 'Avg.Playtime(min)',
      dodDecimals: 1,
    },
    'm2': {
      index: 10,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? columnWidth.five - upDownWidth : 120,
      name: formatMessage({ id: 'overview_monthly_Month_M2' }),
      rainbowKey: 'M2',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'm3': {
      index: 11,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? columnWidth.five - upDownWidth : 114,
      name: formatMessage({ id: 'overview_monthly_Month_M3' }),
      rainbowKey: 'M3',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'm4': {
      index: 12,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? columnWidth.five - upDownWidth : 114,
      name: formatMessage({ id: 'overview_monthly_Month_M4' }),
      rainbowKey: 'M4',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'paid_users': {
      index: 13,
      width: columnWidth.seven,
      onlyValueWidth: locale === 'en-US' ? 102 : 120,
      name: formatMessage({ id: 'overview_Payer' }),
      rainbowKey: 'Payer',
      isUserType: true,
      dodDecimals: 1,
    },
    'payer_rate': {
      index: 14,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 116 : 136,
      name: formatMessage({ id: 'overview_Payer%' }),
      rainbowKey: 'Payer%',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'arpu': {
      index: 15,
      width: 166,
      onlyValueWidth: locale === 'en-US' ? 136 : 166,
      name: formatMessage({ id: 'overview_ARPU($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'ARPU($)',
      dodDecimals: 1,
    },
    'arppu': {
      index: 16,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 146 : 176,
      name: formatMessage({ id: 'overview_ARPPU($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'ARPPU($)',
      dodDecimals: 1,
    },
    'new_paid_users': {
      index: 17,
      width: locale === 'en-US' ? columnWidth.nine : columnWidth.eight,
      onlyValueWidth: locale === 'en-US' ? 190 : 152,
      name: formatMessage({ id: 'overview_New_Payer' }),
      rainbowKey: 'First-time Payer',
      isUserType: true,
      dodDecimals: 1,
    },
    'new_pay_amount': {
      index: 19,
      width: locale === 'en-US' ? 260 : columnWidth.fifteen,
      onlyValueWidth: locale === 'en-US' ? 260 : 205,
      name: formatMessage({ id: 'overview_Revenue(new_payer)' }),
      rainbowKey: 'Revenue(first-time payer)',
      dodDecimals: 1,
    },
    'new_arppu': {
      index: 20,
      width: locale === 'en-US' ? columnWidth.eighteen : columnWidth.thirteen, // 需要取列长
      onlyValueWidth: locale === 'en-US' ? columnWidth.eighteen : columnWidth.thirteen,
      name: formatMessage({ id: 'overview_New_Users_ARPPU($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'First-time Payer ARPPU($)',
      dodDecimals: 1,
    },
    'alc': {
      index: 21,
      width: locale === 'en-US' ? 200 : 180,
      onlyValueWidth: locale === 'en-US' ? 200 : 180,
      name: formatMessage({ id: 'overview_Avg.Login_Count' }),
      rainbowKey: 'Sessions per user',
      dodDecimals: 1,
    },
    'retention_users': {
      index: 22,
      width: locale === 'en-US' ? 228 : 216,
      onlyValueWidth: locale === 'en-US' ? 228 : 216,
      name: formatMessage({ id: 'overview_monthly_MAU_Retention_Users' }),
      rainbowKey: 'MAU Retention Users',
      isUserType: true,
      dodDecimals: 1,
    },
    'churn_users': {
      index: 23,
      width: columnWidth.ten,
      onlyValueWidth: locale === 'en-US' ? 156 : columnWidth.ten - upDownWidth,
      name: formatMessage({ id: 'overview_monthly_Churn_Users' }),
      rainbowKey: 'Churn Users',
      isUserType: true,
      dodDecimals: 1,
    },
    'churn_rate': {
      index: 24,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 120 : 104,
      name: formatMessage({ id: 'overview_Churn%' }),
      rainbowKey: 'Churn%',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'return_users': {
      index: 25,
      width: columnWidth.ten,
      onlyValueWidth: locale === 'en-US' ? 204 : columnWidth.ten - upDownWidth,
      name: formatMessage({ id: 'overview_monthly_MAU_Return_Users' }),
      rainbowKey: 'MAU Return Users',
      isUserType: true,
      dodDecimals: 1,
    },
    'weighted_m2': {
      index: 26,
      width: locale === 'en-US' ? columnWidth.six : columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 166 : 152,
      name: formatMessage({ id: 'overview_monthly_Weighted_M2' }),
      rainbowKey: 'Weighted M2',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_m3': {
      index: 27,
      width: locale === 'en-US' ? columnWidth.six : columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 166 : 146,
      name: formatMessage({ id: 'overview_monthly_Weighted_M3' }),
      rainbowKey: 'Weighted M3',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'weighted_m4': {
      index: 28,
      width: locale === 'en-US' ? columnWidth.six : columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 166 : 146,
      name: formatMessage({ id: 'overview_monthly_Weighted_M4' }),
      rainbowKey: 'Weighted M4',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
  };


  const COLUMN_CONFIG_ALL: any = {
    day: COLUMN_CONFIG_DAY,
    week: COLUMN_CONFIG_WEEK,
    month: COLUMN_CONFIG_MONTH,
  };

  // 日
  const COLUMN_CONFIG_VERSION = {
    // ['pay_amount', 'active_users','new_users','d2_t1','paid_users','arpu','arppu','payer_rate','total_users']
    'pay_amount': {
      index: 1,
      width: columnWidth.twelve,
      onlyValueWidth: columnWidth.twelve - upDownWidth,
      name: formatMessage({ id: 'overview_Revenue($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'Revenue($)',
    },
    'active_users': {
      index: 2,
      width: columnWidth.eight,
      onlyValueWidth: columnWidth.eight - upDownWidth,
      name: formatMessage({ id: 'overview_daily_DAU' }),
      rainbowKey: 'DAU',
      isUserType: true,
    },
    'new_users': {
      index: 3,
      width: columnWidth.eight,
      onlyValueWidth: columnWidth.eight - upDownWidth,
      name: formatMessage({ id: 'overview_New' }),
      rainbowKey: 'New',
      isUserType: true,
    },
    'd2_t1': {
      index: 4,
      width: columnWidth.five,
      onlyValueWidth: columnWidth.five - upDownWidth,
      name: formatMessage({ id: 'overview_daily_D2(T-1)'}),
      rainbowKey: 'D2(T-1)',
      isPercent: true,
      decimals: 2,
    },
    'paid_users': {
      index: 5,
      width: columnWidth.six,
      onlyValueWidth: locale === 'en-US' ? 104 : 120,
      name: formatMessage({ id: 'overview_Payer' }),
      rainbowKey: 'Payer',
      isUserType: true,
      dodDecimals: 1,
    },
    'arpu': {
      index: 6,
      width: locale === 'en-US' ? columnWidth.five : 166,
      onlyValueWidth: locale === 'en-US' ? 136 : 166,
      name: formatMessage({ id: 'overview_ARPU($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'ARPU($)',
      dodDecimals: 1,
    },
    'arppu': {
      index: 7,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 146 : 166,
      name: formatMessage({ id: 'overview_ARPPU($)' }, { unit: getMonetUnit() }),
      rainbowKey: 'ARPPU($)',
      dodDecimals: 1,
    },
    'payer_rate': {
      index: 8,
      width: columnWidth.five,
      onlyValueWidth: locale === 'en-US' ? 116 : 136,
      name: formatMessage({ id: 'overview_Payer%' }),
      rainbowKey: 'Payer%',
      isPercent: true,
      decimals: 2,
      dodDecimals: 1,
    },
    'total_users': {
      index: 1,
      width: columnWidth.ten,
      onlyValueWidth: locale === 'en-US' ? columnWidth.ten - upDownWidth : 152,
      name: formatMessage({ id: 'overview_TRU' }),
      rainbowKey: 'TNU',
      isUserType: true,
    }

  };

  return {
    GROUPS,
    DEFAULT_VALUE,
    ACCUMULATED_OPTIONS,
    SEPARATED_OPTIONS,
    GROUP_BY_TABLE,
    GROUP_BY_KEY_TABLE,
    GROUP_BY_INDEX,
    OPERATION_KEY_LIST,
    OPERATION_ROW,
    OPERATION_GROUP,
    OPERATION_KEY_GROUP,
    COLUMN_CONFIG_ALL,
    COLUMN_CONFIG_VERSION,
    columnWidth
  };

}









